import * as React from "react";
import {cs} from "../../../../react/chain-services";
import {ErrorHighlighter} from "../../../light/error-highlighter";
import {Static2} from "../../../../react/static-2";
import {scrollIntoView} from "../../../light/scroll-into-view";

export const ErrorMessagesLogic = ({next}) => cs(
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ({domRef, eh,}) => next((validations) => ({
        active: validations.find((v) => v.hasError),
        highlightErrors: () => {
            eh.start();
            scrollIntoView(domRef.get());
        },
        domRef, eh,
        validations,
    }))
);
